module.exports = __webpack_public_path__ + "r-v3/img/laser-pointer_on.7a34d9cf.svg";